import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginTop: Spacings.s48,
    },
    skeletonRoot: {
      extend: 'root',
      margin: 'auto',
    },
    title: {
      marginBottom: Spacings.s48,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s30,
      textAlign: 'center',
      color: TextColors.base,

      '& > span': {
        fontWeight: FontWeights.bold,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s24,
      },
    },
    itemWrapper: {},
    textItem: {
      marginTop: Spacings.s32,

      '&.noMargin': {
        marginTop: Spacings.s0,
      },
    },
    skeletonTextItem: {
      extend: 'textItem',
      height: 20,
      maxWidth: '30%',
      margin: 'auto',
    },
    boldText: {
      display: 'block',
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s24,
      textAlign: 'center',
      color: TextColors.base,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s20,
      },
    },
    text: {
      display: 'block',
      marginTop: Spacings.s12,
      fontSize: FontSizes.s20,
      textAlign: 'center',
      color: TextColors.base,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s16,
      },
    },
    divider: {
      display: 'block',
      height: 158,
      width: 0,
      borderLeft: `2px solid ${BackgroundColors.tint3}`,
      borderTop: 'none',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        margin: [Spacings.s48, 'auto'],
        width: 200,
        height: 0,
        borderTop: `1px solid ${BackgroundColors.tint3}`,
        borderLeft: 'none',
      },
    },
    longText: {
      marginTop: Spacings.s56,
      fontSize: FontSizes.s20,
      textAlign: 'center',
      color: TextColors.base,

      '& > span': {
        fontWeight: FontWeights.bold,
        color: TextColors.base,
      },
    },
    textsWrapper: {
      justifyContent: 'space-around',
      display: 'flex',

      [BreakPointsMedia.LG]: {
        display: 'block',
      },
    },
    skeletonTextsWrapper: {
      extend: 'textsWrapper',
      height: 100,
    },
  }),
  {
    name: 'brands-text',
  },
);

export default useStyles;
